export default "__VITE_ASSET__CmyAlx7H__"